import type { SVGProps } from 'react';

const SvgShareWithMe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 15h-.59l.29-.29a.996.996 0 1 0-1.41-1.41l-2 2a.996.996 0 0 0 0 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.29-.29h.59c1.65 0 3 1.35 3 3 0 .55.45 1 1 1s1-.45 1-1c0-2.76-2.24-5-5-5zm-5.1-3.17A3.49 3.49 0 0 1 8.5 8.5C8.5 6.57 10.07 5 12 5s3.5 1.57 3.5 3.5c0 .41-.07.81-.21 1.19-.19.52.08 1.09.6 1.28a1 1 0 0 0 1.28-.6c.22-.6.33-1.23.33-1.87C17.5 5.47 15.03 3 12 3a5.51 5.51 0 0 0-5.5 5.5c0 1.33.49 2.57 1.31 3.54A8.95 8.95 0 0 0 3 20c0 .55.45 1 1 1s1-.45 1-1c0-2.97 1.84-5.55 4.6-6.56.22.11.44.21.68.28.1.03.21.05.31.05.42 0 .81-.27.95-.69a.997.997 0 0 0-.64-1.26z"
    />
  </svg>
);
export default SvgShareWithMe;
